import {ReactElement} from 'react'
import {renaissanceIcon} from './renaissance-icon.module.scss'

export function RenaissanceIcon(): ReactElement {
  return <div className={renaissanceIcon} />
}
